export const mappingDialogContentClass = "sm:tw-max-w-lg tw-gap-2";

export const mappingDialogHeaderClass = "tw-space-y-0";

export const mappingDialogBodyClass = "tw-relative tw-space-y-2";

export const mappingDialogDropdownClass =
  "[&_.dropDownMain]:!tw-pt-0 [&_.dropDownMain]:!tw-mt-0 [&_.selectPadding]:!tw-mt-0 [&_br]:tw-hidden [&_.dropDownTextLabel:empty]:tw-hidden";

export const mappingDialogFooterClass = "tw-gap-2 tw-pt-2";

export const mappingDialogLoadingOverlayClass =
  "tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-md tw-bg-background/60";
